import { render, staticRenderFns } from "./ComponentTextResume.vue?vue&type=template&id=2f51c2e9"
import script from "./ComponentTextResume.vue?vue&type=script&lang=js"
export * from "./ComponentTextResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f51c2e9')) {
      api.createRecord('2f51c2e9', component.options)
    } else {
      api.reload('2f51c2e9', component.options)
    }
    module.hot.accept("./ComponentTextResume.vue?vue&type=template&id=2f51c2e9", function () {
      api.rerender('2f51c2e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/ComponentTextResume.vue"
export default component.exports